import { useState } from 'react';

const faqs = [
  {
    question: '重生萝莉岛是什么类型的游戏？',
    answer: '重生萝莉岛是一款以神秘岛屿为背景的重生冒险题材角色扮演游戏，融合了萌系角色养成、奇幻剧情探索、战斗冒险等多种元素。玩家将在岛屿上展开冒险，结识可爱的萝莉伙伴，揭开岛屿背后的秘密。',
  },
  {
    question: '新手应该从哪里开始玩？',
    answer: '建议新手从启程之村开始，按照主线任务逐步推进。同时可以参考我们攻略区的"新手入门完全攻略"文章，里面详细介绍了基础操作、资源收集、战斗系统和伙伴培养等核心内容。',
  },
  {
    question: '重生萝莉岛有多少个可招募的伙伴？',
    answer: '目前版本共有12位可招募的伙伴角色，其中包括4位主线必得伙伴、5位支线招募伙伴和3位隐藏伙伴。每位伙伴都有独特的背景故事、技能体系和羁绊剧情，收集全部伙伴是许多玩家的目标。',
  },
  {
    question: '重生机制有什么特殊之处？',
    answer: '重生萝莉岛的重生机制非常独特。每次"死亡"后，你会在最近的生命石碑处重生，并保留部分经验值。随着重生次数的增加，角色还会逐渐觉醒特殊能力。这不仅是一个游戏机制，更体现了"失败是新的开始"的积极主题。',
  },
  {
    question: '如何快速提升等级？',
    answer: '快速升级的核心策略是：优先推进主线任务获取丰厚经验奖励，中期利用副本刷级配合组队加成，后期通过每日委托和紧急委托稳定获取经验。使用经验药水和双倍经验卷轴可以进一步加速升级过程。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
            常见问题
          </h2>
          <p className="text-foreground-600">关于重生萝莉岛，你可能想了解的问题</p>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}